import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import Dialog from '~components/Dialog/Dialog';
import DialogActions from '~components/Dialog/DialogActions';
import DialogContent from '~components/Dialog/DialogContent';
import DialogHeader from '~components/Dialog/DialogHeader';
import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';

interface CreateAddonsConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function CreateAddonsConfirmationDialog({
  open,
  onClose,
  onConfirm,
}: CreateAddonsConfirmationDialogProps) {
  return (
    <Dialog isOpen={open} onClose={onClose} maxWidth="xs">
      <DialogHeader onClose={onClose}>
        {t('approvals.driver_pay.settlements.create_addons_dialog.title')}
      </DialogHeader>

      <DialogContent>
        <Box sx={{ py: 1 }}>
          <Typography variant="body2">
            {t('approvals.driver_pay.settlements.create_addons_dialog.message')}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <SmallButton variant="outlined" color="secondary" onClick={onClose}>
          {t('approvals.driver_pay.settlements.create_addons_dialog.cancel_button_text')}
        </SmallButton>

        <SmallButton variant="contained" color="primary" onClick={onConfirm}>
          {t('approvals.driver_pay.settlements.create_addons_dialog.confirm_button_text')}
        </SmallButton>
      </DialogActions>
    </Dialog>
  );
}
